// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3a66f98","455":"45d4bea9","457":"b5bab516","977":"642f6525"}[chunkId] + ".chunk.js";
};